import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { IconeCarregando } from 'src/componentes'
import IconeLivroAberto from 'src/componentes/icones/livro-aberto'
import IconeStackedBooks from 'src/componentes/icones/pilha-livros'
import IconeProfessor from 'src/componentes/icones/professor'
import IconeTimePessoas from 'src/componentes/icones/time-pessoas'
import {
  RotasAlunoCertificacao,
  RotasCursoCertificacao,
  RotasTurmaCertificacao,
  RotasProfessorCertificacao
} from 'src/rotas'
import { Api } from 'src/servicos'

import { Card, Stack } from './styles'

export const PaginaInicialCertificacao: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [totalCursos, setTotalCursos] = useState<number>(0)
  const [totalTurmas, setTotalTurmas] = useState<number>(0)
  const [totalAlunos, setTotalAlunos] = useState<number>(0)
  const [totalProfessores, setTotalProfessores] = useState<number>(0)

  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = usuario ? JSON.parse(usuario) : null
  const usuarioId = usuarioObj?.id

  const history = useHistory()

  useEffect(() => {
    let componenteMontado = true

    const buscarTotalCursos = async () => {
      if (!usuarioId) {
        if (componenteMontado) {
          setIsLoading(false)
        }
        return
      }

      try {
        const [cursos, turmas, alunos, professores] = await Promise.all([
          Api.ObterTotalCursos(usuarioId),
          Api.ObterTotalTurma(usuarioId),
          Api.ObterTotalAlunos(usuarioId),
          Api.ObterTotalProfessores(usuarioId)
        ])

        if (!componenteMontado) return

        setTotalCursos(cursos.total)
        setTotalTurmas(turmas.total)
        setTotalAlunos(alunos.total)
        setTotalProfessores(professores.total)
      } catch (error) {
        if (!componenteMontado) return

        // eslint-disable-next-line no-console
        console.error('Erro ao buscar total de cursos:', error)
      } finally {
        if (componenteMontado) {
          setIsLoading(false)
        }
      }
    }

    buscarTotalCursos()

    return () => {
      componenteMontado = false
    }
  }, [usuarioId])
  const informacoes = [
    {
      id: 1,
      titulo: 'Cursos Cadastrados',
      icon: <IconeLivroAberto style={{ width: '60px', height: '60px' }} />,
      valor: totalCursos,
      page: RotasCursoCertificacao.Cursos
    },
    {
      id: 2,
      titulo: 'Turmas Cadastradas',
      icon: (
        <IconeStackedBooks
          style={{ width: '60px', height: '60px', fontWeight: 600 }}
        />
      ),
      valor: totalTurmas,
      page: RotasTurmaCertificacao.Turmas
    },
    {
      id: 3,
      titulo: 'Professores Cadastrados',
      icon: <IconeProfessor style={{ width: '60px', height: '60px' }} />,
      valor: totalProfessores,
      page: RotasProfessorCertificacao.Professores
    },
    {
      id: 4,
      titulo: 'Alunos Cadastrados',
      icon: <IconeTimePessoas style={{ width: '60px', height: '60px' }} />,
      valor: totalAlunos,
      page: RotasAlunoCertificacao.Alunos
    }
  ]

  return (
    <Stack
      direction={'row'}
      justifyContent={'flex-start'}
      alignItems={'center'}
      gap={'10px'}
      style={{ flexWrap: 'wrap' }}
    >
      {informacoes.map(info => (
        <Card key={info.id} onClick={() => history.push(info.page)}>
          <Stack
            justifyContent={'center'}
            alignItems={'flex-start'}
            gap={'5px'}
            direction={'column'}
          >
            <Stack
              justifyContent={'space-between'}
              alignItems={'flex-start'}
              gap={'15px'}
              direction={'row'}
            >
              <div
                style={{ fontWeight: 600, fontSize: '20px', marginTop: '10px' }}
              >
                {info.titulo}
              </div>
              {info.icon}
            </Stack>
            <div style={{ fontSize: '25px' }}>
              {isLoading ? IconeCarregando : info.valor}
            </div>
          </Stack>
        </Card>
      ))}
    </Stack>
  )
}
